import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UNA from '../theme';
import logoUNA from '../assets/logo_una.jpg';

const datosIniciales = {
  usuarios: [
    { id: 1, nombre: 'Juan Mora', rol: 'instructor', correo: 'juan@una.cr' },
    { id: 2, nombre: 'Josué Lizano', rol: 'alumno', correo: 'josue@una.cr' },
    { id: 3, nombre: 'Admin General', rol: 'admin', correo: 'admin@una.cr' },
    { id: 4, nombre: 'María León', rol: 'alumno', correo: 'maria@una.cr' },
    { id: 5, nombre: 'Carlos Vega', rol: 'instructor', correo: 'carlos@una.cr' },
    { id: 6, nombre: 'Andrea Solís', rol: 'alumno', correo: 'andrea@una.cr' },
    { id: 7, nombre: 'Luis Fallas', rol: 'alumno', correo: 'luis@una.cr' },
    { id: 8, nombre: 'Karina Mora', rol: 'alumno', correo: 'karina@una.cr' },
  ],
  talleres: [
    { id: 1, titulo: 'Introducción a Python', instructor: 'Juan Mora' },
    { id: 2, titulo: 'Excel Avanzado', instructor: 'Carlos Vega' },
    { id: 3, titulo: 'Estadística Aplicada', instructor: 'Juan Mora' },
  ],
  grupos: [
    { id: 1, tallerId: 1, nombre: 'Python - Mayo 2026', inicio: '2026-05-01', fin: '2026-06-30', instructores: [1], estudiantes: [2, 4] },
    { id: 2, tallerId: 2, nombre: 'Excel - Mayo 2026', inicio: '2026-05-15', fin: '2026-06-15', instructores: [5], estudiantes: [2] },
  ],
};

const coloresRol = {
  admin:      { bg: '#f9eaea', color: '#9B1D20' },
  instructor: { bg: '#fff8e1', color: '#e65100' },
  alumno:     { bg: '#e8f5e9', color: '#2e7d32' },
};

function Badge({ rol }) {
  const c = coloresRol[rol] || coloresRol.alumno;
  return (
    <span style={{ fontSize: '11px', fontWeight: '600', padding: '3px 10px', borderRadius: '12px', background: c.bg, color: c.color }}>
      {rol}
    </span>
  );
}

function Btn({ children, onClick, variante = 'primario', disabled = false, style = {} }) {
  const estilos = {
    primario:   { background: UNA.rojo, color: 'white' },
    secundario: { background: '#f0f0f0', color: '#444' },
    peligro:    { background: UNA.rojoClaro, color: UNA.rojo },
  };
  return (
    <button onClick={onClick} disabled={disabled}
      style={{ border: 'none', padding: '9px 18px', borderRadius: '8px', cursor: disabled ? 'not-allowed' : 'pointer', fontWeight: '600', fontSize: '13px', opacity: disabled ? 0.5 : 1, ...estilos[variante], ...style }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.opacity = '0.85'; }}
      onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}>
      {children}
    </button>
  );
}

function BuscadorEstudiantes({ usuarios, inscritos, onAgregar }) {
  const [busqueda, setBusqueda] = useState('');
  const alumnos = usuarios.filter(u => u.rol === 'alumno');
  const resultados = alumnos.filter(u =>
    !inscritos.includes(u.id) &&
    (u.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
      u.correo.toLowerCase().includes(busqueda.toLowerCase()))
  );

  return (
    <div style={{ position: 'relative' }}>
      <input
        value={busqueda}
        onChange={e => setBusqueda(e.target.value)}
        placeholder="Buscar por nombre o correo..."
        style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }}
        onFocus={e => e.target.style.borderColor = UNA.rojo}
        onBlur={e => e.target.style.borderColor = '#ddd'}
      />
      {busqueda && (
        <div style={{ position: 'absolute', top: '44px', left: 0, right: 0, background: 'white', border: '1px solid #eee', borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.1)', zIndex: 100, maxHeight: '200px', overflowY: 'auto' }}>
          {resultados.length === 0 ? (
            <p style={{ padding: '12px 16px', color: '#aaa', fontSize: '13px', margin: 0 }}>No se encontraron estudiantes</p>
          ) : (
            resultados.map(u => (
              <div key={u.id}
                onClick={() => { onAgregar(u.id); setBusqueda(''); }}
                style={{ padding: '10px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #f5f5f5' }}
                onMouseEnter={e => e.currentTarget.style.background = '#fafafa'}
                onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                <div>
                  <p style={{ margin: 0, fontSize: '14px', fontWeight: '500', color: UNA.texto }}>{u.nombre}</p>
                  <p style={{ margin: 0, fontSize: '12px', color: '#888' }}>{u.correo}</p>
                </div>
                <span style={{ fontSize: '12px', color: UNA.rojo, fontWeight: '600' }}>+ Agregar</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

function PanelInscripcion({ grupo, datos, setDatos, onCerrar }) {
  const agregar = (userId) => {
    setDatos(d => ({
      ...d,
      grupos: d.grupos.map(g =>
        g.id === grupo.id ? { ...g, estudiantes: [...g.estudiantes, userId] } : g
      )
    }));
  };

  const quitar = (userId) => {
    setDatos(d => ({
      ...d,
      grupos: d.grupos.map(g =>
        g.id === grupo.id ? { ...g, estudiantes: g.estudiantes.filter(id => id !== userId) } : g
      )
    }));
  };

  const grupoActual = datos.grupos.find(g => g.id === grupo.id);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'white', borderRadius: '16px', padding: '2rem', width: '100%', maxWidth: '500px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <div>
            <h2 style={{ margin: 0, color: UNA.texto }}>Inscribir estudiantes</h2>
            <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#888' }}>{grupo.nombre}</p>
          </div>
          <button onClick={onCerrar} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#888' }}>✕</button>
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ fontSize: '13px', fontWeight: '600', color: '#444', display: 'block', marginBottom: '8px' }}>Buscar y agregar estudiante</label>
          <BuscadorEstudiantes
            usuarios={datos.usuarios}
            inscritos={grupoActual.estudiantes}
            onAgregar={agregar}
          />
        </div>

        <div>
          <p style={{ fontSize: '13px', fontWeight: '600', color: '#444', margin: '0 0 10px' }}>
            Estudiantes inscritos ({grupoActual.estudiantes.length})
          </p>
          {grupoActual.estudiantes.length === 0 ? (
            <p style={{ fontSize: '13px', color: '#aaa', padding: '12px', background: '#fafafa', borderRadius: '8px', textAlign: 'center' }}>Sin estudiantes inscritos aún</p>
          ) : (
            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {datos.usuarios.filter(u => grupoActual.estudiantes.includes(u.id)).map(u => (
                <div key={u.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                  <div>
                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>{u.nombre}</p>
                    <p style={{ margin: 0, fontSize: '12px', color: '#888' }}>{u.correo}</p>
                  </div>
                  <button onClick={() => quitar(u.id)}
                    style={{ background: UNA.rojoClaro, border: 'none', color: UNA.rojo, padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>
                    Quitar
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Dashboard({ datos }) {
  const stats = [
    { titulo: 'Usuarios', valor: datos.usuarios.length, icono: '👥' },
    { titulo: 'Talleres', valor: datos.talleres.length, icono: '📚' },
    { titulo: 'Profesores', valor: datos.usuarios.filter(u => u.rol === 'instructor').length, icono: '👨‍🏫' },
    { titulo: 'Alumnos', valor: datos.usuarios.filter(u => u.rol === 'alumno').length, icono: '🎓' },
    { titulo: 'Grupos activos', valor: datos.grupos.length, icono: '🧑‍🤝‍🧑' },
  ];
  return (
    <div>
      <h1 style={{ margin: '0 0 8px', fontSize: '1.8rem', color: UNA.texto }}>Panel Administrativo</h1>
      <p style={{ color: UNA.textoSuave, marginBottom: '2rem' }}>Gestión general de la plataforma de talleres UNA</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px,1fr))', gap: '1.25rem', marginBottom: '2rem' }}>
        {stats.map((s, i) => (
          <div key={i} style={{ background: 'white', borderRadius: '16px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderTop: `5px solid ${UNA.rojo}` }}>
            <div style={{ fontSize: '2rem', marginBottom: '10px' }}>{s.icono}</div>
            <h2 style={{ margin: 0, fontSize: '28px', color: UNA.texto }}>{s.valor}</h2>
            <p style={{ margin: '6px 0 0', color: UNA.textoSuave }}>{s.titulo}</p>
          </div>
        ))}
      </div>
      <div style={{ background: 'white', borderRadius: '16px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <h2 style={{ margin: '0 0 1rem', color: UNA.texto }}>Grupos activos</h2>
        {datos.grupos.map(g => {
          const taller = datos.talleres.find(t => t.id === g.tallerId);
          return (
            <div key={g.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
              <div>
                <p style={{ margin: 0, fontWeight: '600', color: UNA.texto }}>{g.nombre}</p>
                <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#888' }}>{taller?.titulo} · {g.estudiantes.length} estudiantes</p>
              </div>
              <span style={{ fontSize: '12px', color: '#888' }}>{g.inicio} → {g.fin}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Usuarios({ datos, setDatos }) {
  const [mostrarForm, setMostrarForm] = useState(false);
  const [form, setForm] = useState({ nombre: '', correo: '', rol: 'alumno' });

  const agregar = () => {
    if (!form.nombre || !form.correo) return;
    setDatos(d => ({ ...d, usuarios: [...d.usuarios, { ...form, id: Date.now() }] }));
    setForm({ nombre: '', correo: '', rol: 'alumno' });
    setMostrarForm(false);
  };

  const eliminar = (id) => setDatos(d => ({ ...d, usuarios: d.usuarios.filter(u => u.id !== id) }));

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.8rem', color: UNA.texto }}>Usuarios</h1>
          <p style={{ color: UNA.textoSuave, margin: '4px 0 0' }}>Gestión de todos los usuarios de la plataforma</p>
        </div>
        <Btn onClick={() => setMostrarForm(!mostrarForm)}>+ Nuevo usuario</Btn>
      </div>

      {mostrarForm && (
        <div style={{ background: 'white', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          {[
            { label: 'Nombre completo', key: 'nombre', placeholder: 'Nombre' },
            { label: 'Correo institucional', key: 'correo', placeholder: 'usuario@una.cr' },
          ].map(f => (
            <div key={f.key}>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>{f.label}</label>
              <input value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                placeholder={f.placeholder}
                style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
            </div>
          ))}
          <div>
            <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Rol</label>
            <select value={form.rol} onChange={e => setForm({ ...form, rol: e.target.value })}
              style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
              <option value="alumno">Alumno</option>
              <option value="instructor">Instructor</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px' }}>
            <Btn onClick={agregar} style={{ flex: 1 }}>Guardar</Btn>
            <Btn onClick={() => setMostrarForm(false)} variante="secundario" style={{ flex: 1 }}>Cancelar</Btn>
          </div>
        </div>
      )}

      <div style={{ background: 'white', borderRadius: '16px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa', textAlign: 'left' }}>
              {['Nombre', 'Correo', 'Rol', 'Acción'].map(h => (
                <th key={h} style={{ padding: '14px', color: '#444', fontSize: '13px', fontWeight: '600' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {datos.usuarios.map(u => (
              <tr key={u.id} style={{ borderTop: '1px solid #eee' }}>
                <td style={{ padding: '14px', fontWeight: '500' }}>{u.nombre}</td>
                <td style={{ padding: '14px', color: '#666' }}>{u.correo}</td>
                <td style={{ padding: '14px' }}><Badge rol={u.rol} /></td>
                <td style={{ padding: '14px' }}>
                  <Btn onClick={() => eliminar(u.id)} variante="peligro">Eliminar</Btn>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Grupos({ datos, setDatos }) {
  const [mostrarForm, setMostrarForm] = useState(false);
  const [form, setForm] = useState({ tallerId: '', nombre: '', inicio: '', fin: '', instructores: [] });
  const [grupoInscripcion, setGrupoInscripcion] = useState(null);

  const toggleInstructor = (id) => {
    setForm(f => ({
      ...f,
      instructores: f.instructores.includes(id) ? f.instructores.filter(x => x !== id) : [...f.instructores, id]
    }));
  };

  const agregar = () => {
    if (!form.tallerId || !form.nombre || !form.inicio || !form.fin) return;
    setDatos(d => ({ ...d, grupos: [...d.grupos, { ...form, id: Date.now(), tallerId: parseInt(form.tallerId), estudiantes: [] }] }));
    setForm({ tallerId: '', nombre: '', inicio: '', fin: '', instructores: [] });
    setMostrarForm(false);
  };

  const eliminar = (id) => setDatos(d => ({ ...d, grupos: d.grupos.filter(g => g.id !== id) }));
  const instructores = datos.usuarios.filter(u => u.rol === 'instructor');

  return (
    <div>
      {grupoInscripcion && (
        <PanelInscripcion
          grupo={grupoInscripcion}
          datos={datos}
          setDatos={setDatos}
          onCerrar={() => setGrupoInscripcion(null)}
        />
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.8rem', color: UNA.texto }}>Grupos</h1>
          <p style={{ color: UNA.textoSuave, margin: '4px 0 0' }}>Cada grupo es una ejecución de un taller en un período</p>
        </div>
        <Btn onClick={() => setMostrarForm(!mostrarForm)}>+ Nuevo grupo</Btn>
      </div>

      {mostrarForm && (
        <div style={{ background: 'white', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Taller</label>
              <select value={form.tallerId} onChange={e => setForm({ ...form, tallerId: e.target.value })}
                style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                <option value="">Seleccionar taller...</option>
                {datos.talleres.map(t => <option key={t.id} value={t.id}>{t.titulo}</option>)}
              </select>
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Nombre del grupo</label>
              <input value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })}
                placeholder="Ej: Python - Mayo 2026"
                style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Fecha inicio</label>
              <input type="date" value={form.inicio} onChange={e => setForm({ ...form, inicio: e.target.value })}
                style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '6px' }}>Fecha fin</label>
              <input type="date" value={form.fin} onChange={e => setForm({ ...form, fin: e.target.value })}
                style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
            </div>
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ fontSize: '13px', color: '#444', display: 'block', marginBottom: '8px', fontWeight: '600' }}>Instructores</label>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {instructores.map(u => (
                <label key={u.id} style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '14px', background: form.instructores.includes(u.id) ? UNA.rojoClaro : '#f5f5f5', padding: '6px 12px', borderRadius: '8px', border: form.instructores.includes(u.id) ? `1.5px solid ${UNA.rojo}` : '1.5px solid transparent' }}>
                  <input type="checkbox" checked={form.instructores.includes(u.id)} onChange={() => toggleInstructor(u.id)} style={{ accentColor: UNA.rojo }} />
                  {u.nombre}
                </label>
              ))}
            </div>
          </div>
          <p style={{ fontSize: '12px', color: '#aaa', margin: '0 0 1rem' }}>💡 Los estudiantes se inscriben después de crear el grupo</p>
          <div style={{ display: 'flex', gap: '10px' }}>
            <Btn onClick={agregar}>Guardar grupo</Btn>
            <Btn onClick={() => setMostrarForm(false)} variante="secundario">Cancelar</Btn>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gap: '1rem' }}>
        {datos.grupos.map(g => {
          const taller = datos.talleres.find(t => t.id === g.tallerId);
          const profes = datos.usuarios.filter(u => g.instructores.includes(u.id));
          const estudiantes = datos.usuarios.filter(u => g.estudiantes.includes(u.id));
          return (
            <div key={g.id} style={{ background: 'white', borderRadius: '16px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderLeft: `5px solid ${UNA.rojo}` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <h3 style={{ margin: '0 0 4px', color: UNA.texto }}>{g.nombre}</h3>
                  <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#888' }}>📚 {taller?.titulo} · {g.inicio} → {g.fin}</p>
                  <div style={{ display: 'flex', gap: '2rem' }}>
                    <div>
                      <p style={{ margin: '0 0 4px', fontSize: '11px', color: '#aaa', fontWeight: '700' }}>INSTRUCTORES</p>
                      {profes.length ? profes.map(p => <p key={p.id} style={{ margin: '2px 0', fontSize: '13px' }}>👨‍🏫 {p.nombre}</p>) : <p style={{ fontSize: '13px', color: '#ccc' }}>Sin asignar</p>}
                    </div>
                    <div>
                      <p style={{ margin: '0 0 4px', fontSize: '11px', color: '#aaa', fontWeight: '700' }}>ESTUDIANTES ({estudiantes.length})</p>
                      {estudiantes.length ? estudiantes.slice(0, 3).map(e => <p key={e.id} style={{ margin: '2px 0', fontSize: '13px' }}>🎓 {e.nombre}</p>) : <p style={{ fontSize: '13px', color: '#ccc' }}>Sin inscritos</p>}
                      {estudiantes.length > 3 && <p style={{ fontSize: '12px', color: '#aaa', margin: '2px 0' }}>+{estudiantes.length - 3} más...</p>}
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-end' }}>
                  <Btn onClick={() => setGrupoInscripcion(g)}>👥 Gestionar inscritos</Btn>
                  <Btn onClick={() => eliminar(g.id)} variante="peligro">Eliminar</Btn>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Talleres({ datos }) {
  return (
    <div>
      <h1 style={{ margin: '0 0 8px', fontSize: '1.8rem', color: UNA.texto }}>Talleres</h1>
      <p style={{ color: UNA.textoSuave, marginBottom: '1.5rem' }}>Talleres disponibles en la plataforma</p>
      <div style={{ display: 'grid', gap: '1rem' }}>
        {datos.talleres.map(t => (
          <div key={t.id} style={{ background: 'white', borderRadius: '12px', padding: '1.25rem 1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: `5px solid ${UNA.rojo}` }}>
            <div>
              <h3 style={{ margin: 0, color: UNA.texto }}>{t.titulo}</h3>
              <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#888' }}>👨‍🏫 {t.instructor}</p>
            </div>
            <span style={{ fontSize: '12px', background: UNA.rojoClaro, color: UNA.rojo, padding: '4px 12px', borderRadius: '12px', fontWeight: '600' }}>
              {datos.grupos.filter(g => g.tallerId === t.id).length} grupos
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Admin() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [seccion, setSeccion] = useState('dashboard');
  const [datos, setDatos] = useState(datosIniciales);

  const menu = [
    { id: 'dashboard', label: '📊 Dashboard' },
    { id: 'usuarios', label: '👥 Usuarios' },
    { id: 'talleres', label: '📚 Talleres' },
    { id: 'grupos', label: '🧑‍🤝‍🧑 Grupos' },
  ];

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'Segoe UI, sans-serif', background: UNA.gris }}>
      <div style={{ width: '240px', background: UNA.rojo, color: 'white', padding: '2rem 1.2rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'fixed', height: '100vh', boxSizing: 'border-box' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '2rem' }}>
            <img src={logoUNA} alt="Logo UNA" style={{ width: '120px' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {menu.map(m => (
              <button key={m.id} onClick={() => setSeccion(m.id)}
                style={{ background: seccion === m.id ? 'rgba(255,255,255,0.2)' : 'transparent', border: 'none', color: 'white', padding: '12px', borderRadius: '8px', textAlign: 'left', cursor: 'pointer', fontSize: '15px', fontWeight: seccion === m.id ? '700' : '400', borderLeft: seccion === m.id ? '3px solid white' : '3px solid transparent' }}
                onMouseEnter={e => { if (seccion !== m.id) e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
                onMouseLeave={e => { if (seccion !== m.id) e.currentTarget.style.background = 'transparent'; }}>
                {m.label}
              </button>
            ))}
          </div>
        </div>
        <button onClick={handleLogout}
          style={{ background: 'white', border: 'none', color: UNA.rojo, padding: '12px', borderRadius: '8px', cursor: 'pointer', fontWeight: '700' }}>
          Cerrar sesión
        </button>
      </div>

      <div style={{ flex: 1, padding: '2rem', marginLeft: '240px' }}>
        {seccion === 'dashboard' && <Dashboard datos={datos} />}
        {seccion === 'usuarios' && <Usuarios datos={datos} setDatos={setDatos} />}
        {seccion === 'talleres' && <Talleres datos={datos} />}
        {seccion === 'grupos' && <Grupos datos={datos} setDatos={setDatos} />}
      </div>
    </div>
  );
}